module.exports = __webpack_public_path__ + "img/hr-H-B-4-unload-connect-shadow.0f90d784.png";